import { render, staticRenderFns } from "./CalendarApp.vue?vue&type=template&id=470aceab&"
import script from "./CalendarApp.vue?vue&type=script&lang=js&"
export * from "./CalendarApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports